export default "__VITE_ASSET__6b7d9bf8__"